(function (global) {

  //CREVIEW Шамов А.: Раз разделил на вкладки все настройки, то и этот файл надо бы разбить по вкладкам.

  /**
  * Блокируем сверх-частый вызов сервиса.
  * В сервисе происходят не самые легкие
  * махинации.
  * @inner
  * @function setLock();
  */
  var themeLock = false;
  var setLock = function () {
    themeLock = true;
    setTimeout(function () { themeLock = false }, 2000);
  };

  var saveTimeout = null;

  /**
  * Функции отвечающие за работу страницы настроек.
  * @namespace Core.settings
  * @since 5.0.0.4200 Версия по интерфейсам
  */
  global.settings = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Действие для кнопки "Переустановить" для агента
  * @method Core.settings.initAgentControls
  */
  global.settings.installAgent = function () {
    var jButton = $('#reinstall');

    WA.agent
    .enable()
    .setSessionInitialized(false);

    InitializeAgentSession(true);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Информация о темах
  */
  global.settings.themes = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Инициализация контролов отвечающих за работу с агентом
  * @method Core.settings.initAgentControls
  */
  global.settings.initAgentControls = WA.TCD(function () {

    var jCheck = $("#isAgentEnabled");
    var jDownload = $("#download");
    var jLaunch = $("#launch");
    var jUploadLogFiles = $("#uploadLogFiles");

    if (WA.agent.isDisabled()) {
      jCheck.prop("checked", true);
      jDownload.addClass('disabled');
      jDownload.attr('disabled', true);
      jLaunch.addClass('disabled');
      jLaunch.attr('disabled', true);
      jUploadLogFiles.addClass('disabled');
      jUploadLogFiles.attr('disabled', true);
    };


    jCheck.on('change', function () {
      if ($(this).is(':checked')) {
        WA.agent.disable();
        jDownload.addClass('disabled');
        jDownload.attr('disabled', true);
        jLaunch.addClass('disabled');
        jLaunch.attr('disabled', true);
        jUploadLogFiles.addClass('disabled');
        jUploadLogFiles.attr('disabled', true);
      } else {
        WA.agent.enable();
        jDownload.removeClass('disabled');
        jDownload.attr('disabled', false);
        jLaunch.removeClass('disabled');
        jLaunch.attr('disabled', false);
        jUploadLogFiles.removeClass('disabled');
        jUploadLogFiles.attr('disabled', false);
      }
      Core.settings.initDocDefaultAction();
      global.settings.saveDocDefaultActionSettings();
      //(new WA.CMP.NTF.Toast()).show(L('SETTINGS_SAVED'));
    });
    return global.settings;
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Вызывает сервис сохранения настроек открытия документов и предпросмотра.
  * @function Core.settings.applyPreviewSettingss
  * @since 5.4.0.1006
  * @return Core.settings
  */
  global.settings.applyPreviewSettings = function (isPreviewEnabled, isColoringRecordsEnabled, isFullscreenPreview, openDocForEditByDefault, openCardByDefault) {

    g_isPreviewEnabled = isPreviewEnabled;
    g_isColoringRecordsEnabled = isColoringRecordsEnabled;
    g_isFullscreenPreview = isFullscreenPreview;
    g_openDocForEditByDefault = openDocForEditByDefault;

    return WA.SRV.call("/Session.asmx/ApplyPreviewSettings", {
      EnablePreview: isPreviewEnabled ? "True" : "False",
      EnableColoringRecords: isColoringRecordsEnabled ? "True" : "False",
      UseFullScreenPreview: isFullscreenPreview ? "True" : "False",
      OpenCardByDefault: openCardByDefault ? "True" : "False",
      OpenDocForEditByDefault: openDocForEditByDefault ? "True" : "False"
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Сохраняет настройки открытия документов и предпросмотра.
  * @function Core.settings.saveDocDefaultActionSettings
  * @since 5.0.0.4200
  * @return Core.settings
  */
  global.settings.saveDocDefaultActionSettings = function () {
    var isPreviewEnabled = $("#chkOpenPreviewFromList").length !== 0
      ? $("#chkOpenPreviewFromList").is(':checked')
      : !WA.agent.isAvailable() && (g_defaultListAction != 'showcard');
    var isColoringRecordsEnabled = $("#chkColoringRecords").length !== 0
      ? $("#chkColoringRecords").is(':checked')
      : g_isColoringRecordsEnabled;
    var isFullscreenPreview = $("#chkOpenFullscreenPreview").length !== 0
      ? $("#chkOpenFullscreenPreview").is(':checked')
      : g_isFullscreenPreview;
    var openDocForEditByDefault = $('#chkOpenDocForEditingDefault').length !== 0
      ? $('#chkOpenDocForEditingDefault').is(':checked')
      : g_openDocForEditByDefault;
    var openCardByDefault = $("#chkOpenCardFromList").length !== 0
      ? $("#chkOpenCardFromList").is(':checked')
      : g_defaultListAction === 'showcard';

    return global.settings.applyPreviewSettings(isPreviewEnabled, isColoringRecordsEnabled, isFullscreenPreview, openDocForEditByDefault, openCardByDefault).done(function (res) {
      (new WA.CMP.NTF.Toast()).show(L('SETTINGS_SAVED'));
    }).always(function () {
      if ($.isFunction(ReloadWindowToLoadPlugin)) ReloadWindowToLoadPlugin();
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Инициализирует настройки предпросмотра.
  * @function Core.settings.initPreviewSettings
  * @since 5.0.0.4200
  * @return Core.settings
  */
  global.settings.initPreviewSettings = WA.TCD(function () {
    $(function () {
      var jOpenFullscreenPreviewChk = $('#chkOpenFullscreenPreview');
      if (g_isFullscreenPreview) {
        jOpenFullscreenPreviewChk.attr('checked', true);
      }
    });

    $("#chkOpenPreviewFromList, #chkOpenEditorFromList, #chkOpenCardFromList")
      .on("change", ViewPreviewSettingsModal_DisableControls)
      .on("change", window.Core.settings.saveDocDefaultActionSettings);

    $("#chkOpenDocForReadingDefault, #chkOpenDocForEditingDefault")
      .on("change", ViewPreviewSettingsModal_ChangePreviewSettings)
      .on("change", window.Core.settings.saveDocDefaultActionSettings);

    return global.settings;
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
* Инициализирует настройки раскраски записей справочников.
* @function Core.settings.initColoringRecordsSettings
* @since 5.2.1.1000
* @return Core.settings
*/
  global.settings.initColoringRecordsSettings = WA.TCD(function () {
    $(function () {
      jColoringRecordsEnabled = $("#chkColoringRecords");

      if (g_isColoringRecordsEnabled) {
        jColoringRecordsEnabled.attr('checked', true);
      }

      if (g_isColoringRecordsSettingsHidden) {
        jColoringRecordsEnabled.attr('disabled', true);
        jColoringRecordsEnabled.parent().attr('title', L("DISABLE_COLORING_RECORD_SETTINGS_HINT"));
        jColoringRecordsEnabled.parent().addClass("field_disabled");
      }
    });

    return global.settings;
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
* Инициализирует настройки автоочистки.
* @function Core.settings.initAutoCleaningSettings
* @since 5.1.0.1515
* @return Core.settings
*/
  global.settings.initAutoCleaningSettings = WA.TCD(function () {

    var jSettingsAutocleaningEnable = $('#settings-autocleaning-enable');
    var jSettingsAutocleaningOnCompletion = $("#settings-autocleaning-oncompletion");
    var jSettingsAutocleaningPeriod = $('#settings-autocleaning-period');
    var jSettingsAutocleaningDefault = $('#settings-autocleaning-default');
    var jSettingsAutocleaningAfterdays = $('#settings-autocleaning-afterdays');
    var AutocleaningDefaultChangeLink = $('.ac-change-link');
    var changedObjects = [
      jSettingsAutocleaningEnable, jSettingsAutocleaningOnCompletion, jSettingsAutocleaningAfterdays,
      jSettingsAutocleaningPeriod
    ];

    //Отключение автоочиски
    jSettingsAutocleaningEnable.on('change', window.Core.settings.switchAutoCleaningSettings);

    //Изменение настроек
    $.each(changedObjects, function (index, value) {
      value.on("change", function () {
        clearTimeout(saveTimeout);
        saveTimeout = setTimeout(window.Core.settings.saveAutoCleaningSettings, 500);
      });
    });

    jSettingsAutocleaningPeriod.on('keydown', function () {
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(window.Core.settings.saveAutoCleaningSettings, 500);
    });

    //Валидатор числа дней
    //$('#settings-autocleaning-period').on('keypress', function (event) {
    //  return event.charCode >= 48 && event.charCode <= 57
    //});
    jSettingsAutocleaningPeriod.Validator("^([-]?|[-]?[\\d]+)$");

    //Настройки по умолчанию
    jSettingsAutocleaningDefault.on('click', window.Core.settings.updateDefaultAutocleaningSettings);

    // Сброс настроек
    AutocleaningDefaultChangeLink.on('click', window.Core.settings.createAutocleaningSettingsFromDefaultSettings);

    return global.settings;
  });

  /**
* Сохраняет настройки автоочистки.
* @function Core.settings.saveAutoCleaningSettings
* @since 5.1.0.1515
* @return Core.settings
*/
  global.settings.saveAutoCleaningSettings = WA.TCD(function () {

    var jSettingsAutocleaningEnable = $('#settings-autocleaning-enable');
    var jSettingsAutocleaningOnCompletion = $("#settings-autocleaning-oncompletion");
    var jSettingsAutocleaningPeriod = $('#settings-autocleaning-period');

    var enableAutoClean = jSettingsAutocleaningEnable.is(':checked');
    var cleanMode = enableAutoClean ? (jSettingsAutocleaningOnCompletion.is(':checked') ? 0 : 1) : 255;
    var linkStoringPeriod = jSettingsAutocleaningPeriod.val();

    //Если режим автоочистки по дням, а количество дней не задано, то не сохраняем
    if ((cleanMode == 1) && (linkStoringPeriod === ""))
      return global.settings;

    //Если введено некорректное значение, то ставим 1
    if (!linkStoringPeriod) {
      linkStoringPeriod = 1;
      jSettingsAutocleaningPeriod.val(1)
    }

    ShowTopSpinner();
    WA.SRV.call("/Session.asmx/ApplyAutoCleanSettings", {
      CleanMode: cleanMode,
      LinkStoringPeriod: linkStoringPeriod
    }).always(function () {
      HideTopSpinner(L('SETTINGS_SAVED'), 2000);
    }).error(function (error) {
      console.log(error);
    });
    return global.settings;
  });

  /**
    * Добавляет папку в список папок автоочистки.
    * @function Core.settings.addAutoCleanFolder
    * @since 5.1.0.1515
    * @return Core.settings
    */
  global.settings.addAutoCleanFolder = WA.TCD(function (list) {
    list.PasteLinks(function (link) {
      return window.Core.settings.setAutoCleanFolder(link.ID, true);
    }, L('SETTINGS_SAVED'));
    return global.settings;
  });

  /**
    * Удаляет папку из список папок автоочистки.
    * @function Core.settings.removeAutoCleanFolder
    * @since 5.1.0.1515
    * @return Core.settings
    */
  global.settings.removeAutoCleanFolder = WA.TCD(function (list) {
    list.DeleteLinks(null, function (link) {
      return window.Core.settings.setAutoCleanFolder(link.ID, false);
    }, L('SETTINGS_SAVED'));
    return global.settings;
  });

  /**
    * Устанавливает статус автоочистки для папки.
    * @function Core.settings.setAutoCleanFolder
    * @since 5.1.0.1515
    * @return Core.settings
    */
  global.settings.setAutoCleanFolder = WA.TCD(function (folderID, enabled) {
    var success = false;
    //CREVIEW Шамов А.: Почему тут callSync? Выше был обычный call
    // Isaev_DM: setAutoCleanFolder завязаны на работу с ссылками, не стал рефакторить пока старый код
    WA.SRV.callSync("/Folder.asmx/SetFolderAutoClean", {
      FolderID: folderID,
      Enabled: enabled
    }, null, null, true).success(function (result) {
      success = true;
    });
    return success;
  });

  /**
    * Устанавливает настройки автоочистки по умолчанию.
    * @function Core.settings.defaultAutoCleaningSettings
    * @since 5.1.0.1515
    * @return Core.settings
    */
  function setAutoCleaningSettings(defaultSettings) {

    if (defaultSettings != null) {

      var autocleaningFolderList = ListRequisite('ctl00_MainContent_ctl00_AutoCleanFolderList');
      var defaultLinks = [];

      var jSettingsAutocleaningEnable = $('#settings-autocleaning-enable');
      var jSettingsAutocleaningOnCompletion = $("#settings-autocleaning-oncompletion");
      var jSettingsAutocleaningPeriod = $('#settings-autocleaning-period');
      var jSettingsAutocleaningAfterdays = $('#settings-autocleaning-afterdays');

      jSettingsAutocleaningOnCompletion.attr('disabled', false);
      jSettingsAutocleaningAfterdays.attr('disabled', false);
      jSettingsAutocleaningPeriod.attr('disabled', false);
      jSettingsAutocleaningPeriod.removeClass('Req_Disabled');

      if (defaultSettings.AllUsersNeedDeleteLinks == "Y")
        jSettingsAutocleaningEnable.prop('checked', true);
      else {
        jSettingsAutocleaningEnable.prop('checked', false);
        jSettingsAutocleaningAfterdays.attr('disabled', true);
        jSettingsAutocleaningPeriod.attr('disabled', true);
        jSettingsAutocleaningOnCompletion.prop('disabled', true);
      }

      if (defaultSettings.AllUsersLinkStoringPeriod == "0") {
        jSettingsAutocleaningAfterdays.prop('checked', false);
        jSettingsAutocleaningOnCompletion.prop('checked', true);
        jSettingsAutocleaningPeriod.val(1);
      } else {
        jSettingsAutocleaningOnCompletion.prop('checked', false);
        jSettingsAutocleaningAfterdays.prop('checked', true);
        jSettingsAutocleaningPeriod.val(defaultSettings.AllUsersLinkStoringPeriod);
      }

      if (defaultSettings.AutoCleanInbox != "0")
        defaultLinks.push({ ID: parseInt(defaultSettings.AutoCleanInbox), Kind: "FOL", CompCode: null });

      if (defaultSettings.AutoCleanOutbox != "0")
        defaultLinks.push({ ID: parseInt(defaultSettings.AutoCleanOutbox), Kind: "FOL", CompCode: null });

      autocleaningFolderList.Clear(function (link) {
        window.Core.settings.setAutoCleanFolder(link.ID, false);
      });

      autocleaningFolderList.AddLinks(defaultLinks, autocleaningFolderList, function (link) {
        return window.Core.settings.setAutoCleanFolder(link.ID, true);
      });

    }

    window.Core.settings.saveAutoCleaningSettings();

  };

  /**
    * Включает/Отключает автоочистку в настройках.
    * @function Core.settings.disableAutoCleaningSettings
    * @since 5.1.0.1515
    * @return Core.settings
    */
  global.settings.switchAutoCleaningSettings = WA.TCD(function () {

    var jSettingsAutocleaningEnable = $('#settings-autocleaning-enable');
    var jSettingsAutocleaningOnCompletion = $("#settings-autocleaning-oncompletion");
    var jSettingsAutocleaningPeriod = $('#settings-autocleaning-period');
    var jSettingsAutocleaningAfterdays = $('#settings-autocleaning-afterdays');

    var disable = !jSettingsAutocleaningEnable.is(":checked");
    jSettingsAutocleaningOnCompletion.attr('disabled', disable);
    jSettingsAutocleaningAfterdays.attr('disabled', disable);
    jSettingsAutocleaningPeriod.attr('disabled', disable);
    if (disable)
      jSettingsAutocleaningPeriod.addClass('Req_Disabled');
    else
      jSettingsAutocleaningPeriod.removeClass('Req_Disabled');
  });

  /**
    * Получает дефолтные настройки автоочистки.
    * @function Core.settings.updateDefaultAutocleaningSettings
    * @since 5.1.0.1515
    * @return Core.settings
    */
  global.settings.updateDefaultAutocleaningSettings = WA.TCD(function () {
    var success = false;
    WA.SRV.call("/Session.asmx/GetDefaultAutocleaningSettings",
      null, null, null, true).success(function (result) {
        setAutoCleaningSettings(result);
        success = true;
      });
    return success;
  });

  /**
    * Создает пользовательские настройки на основе настроек администратора.
    * @function Core.settings.getDefaultAutocleaningSettings
    * @since 5.1.0.1515
    * @return Core.settings
    */
  global.settings.createAutocleaningSettingsFromDefaultSettings = WA.TCD(function () {
    var success = false;
    WA.SRV.call("/Session.asmx/CreateAutocleaningSettingsFromDefaultSettings",
      null, null, null, true).success(function (result) {
        success = true;
        //CREVIEW Isaev_DM: Пересмотреть реализацию в ходе поддержки тестирования
        location.reload();
      });
    return success;
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Устанавливает часовой пояс пользователя.
   * @param {} jObject 
   * @returns {} 
   */
  global.settings.setTimeZone = function(jObject) {
    var pickInstance = jObject.data()['DropDownListInstance'];
    var timeZoneId = pickInstance.getValue();
    
    WebAccess.services.userProfile.setTimeZone(timeZoneId).done(function () {
      var toast = new WA.CMP.NTF.Toast();
      toast.showMessage(L("SETTINGS_SAVED"));
    }).fail(function (err) {
      ShowError(err);
    });
  }

  // Событие change вызывается всегда поэтому модалка
  // снова срабатывает при нажатии на кнопку отмена если убрать cancelLock.
  var cancelLock = false;
  global.settings.setNewLanguage = function (jObject) {
    if (cancelLock) return;

    var handler = arguments.callee;
    var pickInstance = jObject.data()['DropDownListInstance'];

    var lang = pickInstance.getValue();
    var langCaption = pickInstance.getDisplayValue();
    if (lang == pickInstance.prevValue) return;

    var dialog = new WA.CMP.dialogs.MessageBox();
    dialog.isShowCancelButton = true;
    dialog.isShowOkButton = false;
    dialog.removeDefaultButtons();

    var labels = {
      'relogin': L('RELOGIN'),
      'reloginLater': L('OK'),
      'cancel': L('RELOGINCANCEL')
    };

    if (isPassthrough) labels = {
      'relogin': L('RELOGIN_AUTO'),
      'reloginLater': L('RELOGIN_LATER_AUTO')
    };

    var cancel = function () {
      cancelLock = true;
      pickInstance.setPrevValue(false);
      setTimeout(function () { cancelLock = false; }, 100);
    };

    dialog.addButton('ReloginLater', labels.reloginLater, function () {
      WebAccess.services.session.SetNewLanguage(lang);
      WA.CMP.NTF.InlineHint.hideAll();
      WA.CR.inlineHint.showWarning(L('REGIONAL_SETTINGS_LATER_NEW_LANGUAGE', langCaption), null, INLINE_HINT_PRIORITY.PRIMARY);      
    })
    .addButton('CancelButton', L('CANCEL'), cancel)
    .bind('crossClose', cancel)
    .show(L('RELOGIN_DIALOG_MAIN_TEXT'), L('RELOGIN_DIALOG_ADDITIONAL_TEXT'), L('RELOGIN_DIALOG_TITLE'), 'warning')
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
 * Инициализирует настройки открытия документов.
 * @function Core.settings.initDocDefaultAction
 * @since 5.0.0.4200
 * @return Core.settings
 */
  global.settings.initDocDefaultAction = WA.TCD(function () {
    var enableRadioButton = function (jBtn) {
      jBtn.next("label").removeClass('field_disabled');
      jBtn.attr('disabled', false);
    };

    var disableRadioButton = function (jBtn) {
      jBtn.next("label").addClass('field_disabled');
      jBtn.attr('disabled', 'disabled');
    };

    $.when(WA.AgentInit).then(function () {
      var jOpenPreviewFromListChk = $('#chkOpenPreviewFromList');
      var jOpenCardFromListChk = $('#chkOpenCardFromList');
      var jOpenEditorFromListChk = $('#chkOpenEditorFromList');
      var jOpenDocForReadingDefaultChk = $('#chkOpenDocForReadingDefault');
      var jOpenDocForEditingDefaultChk = $('#chkOpenDocForEditingDefault');

      var needDisableAgentSetts = !WA.agent.isAvailable();
      switch (g_defaultListAction) {
        case 'preview':
          jOpenPreviewFromListChk.attr('checked', true);
          break;
        case 'showcard':
          jOpenCardFromListChk.attr('checked', true);
          break;
        case 'open':
          jOpenEditorFromListChk.attr('checked', true);
          break;
        case 'viewineditor':
          jOpenEditorFromListChk.attr('checked', true);
          break;
      }

      if (needDisableAgentSetts && (g_defaultListAction != 'showcard')) {
        jOpenPreviewFromListChk.attr('checked', true);
      }

      if (!g_openDocForEditByDefault) {
        jOpenDocForReadingDefaultChk.attr('checked', true);
      } else {
        jOpenDocForEditingDefaultChk.attr('checked', true);
      }

      if (!needDisableAgentSetts) {
        enableRadioButton(jOpenEditorFromListChk);
      }
      if (!needDisableAgentSetts && !g_isPreviewEnabled && !jOpenCardFromListChk.is(':checked')) {
        enableRadioButton(jOpenDocForReadingDefaultChk);
        enableRadioButton(jOpenDocForEditingDefaultChk);
      }

      if (needDisableAgentSetts) {
        disableRadioButton(jOpenEditorFromListChk);
        disableRadioButton(jOpenDocForReadingDefaultChk);
        disableRadioButton(jOpenDocForEditingDefaultChk);
      }
    });
    return global.settings;
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * DEPRECATED
  * Получает параметры тем из JSON файлов, инициализирует контролы
  * @function Core.settings.loadThemesData
  * @return Core.settings
  * @deprecated As of 5.5.0.1801
  */
  global.settings.loadThemesData = WA.TCD(function (force) {
    return global.settings;
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * DEPRECATED
  * Предварительная настройка контролов отвечающих за изменение темы.
  * @function Core.settings.initThemesEvents
  * @return Core.settings
  * @deprecated As of 5.5.0.1801
  */
  global.settings.initThemesEvents = WA.TCD(function () {
    return global.settings;
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * DEPRECATED
  * Установить выбранный пользователем цвет
  * @function Core.settings.setCustomColor
  * @param {array} rgbColor основной цвет
  * @param {boolean} opt_commit нужно ли сохранить значние в профиле
  * @deprecated As of 5.5.0.1801
  */
  global.settings.setCustomColor = function (rgbColor, opt_commit) {
    return false;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Применить тему.
  * DEPRECATED
  * @function Core.settings.applyTheme
  * @param {string} name - имя темы(gray, green)
  * @param {string} type - вариант темы(dark,light)
  * @param {array} backgroundColor - базовый цвет фона, массив [R(int),G(int),B(int)]
  * @param {array} textColor - базовый цвет текста, массив [R(int),G(int),B(int)]
  * @since 5.0.0.4214
  * @return Core.settings
  * @deprecated As of 5.5.0.1801
  */
  global.settings.applyTheme = function (name, type, backgroundColor, textColor) {
    return false;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * DEPRECATED
  * Смена темы.
  * @function Core.settings.changeTheme
  * @since 5.0.0.4214
  * @return Core.settings
  * @deprecated As of 5.5.0.1801
  */
  global.settings.changeTheme = function (fullName) {
    return global.settings;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /*
  * Инициализировать настройки управляемых папок.
  * @function Core.settings.initManagedFoldersSettings
  * @return Core.settings
  */
  global.settings.initManagedFoldersSettings = WA.TCD(function () {

    $(".all-managed-folders").find("input[type=checkbox]").on("change", function () {
      changeChildControlsCheckedState($(this).parent());
    });

    $(".single-managed-folder").find("input[type=checkbox]").on("change", function () {
      var jChildContainer = $(this).parent().parent();
      var jParentCheckbox = jChildContainer.parent().find(".all-managed-folders").find("input[type=checkbox]");
      global.settings.updateManagedFoldersLinks([$(this).parent().attr("data-control")], $(this).is(":checked"))
      var checkedItemsLength = jChildContainer.find("input[type=checkbox]:checked").length;
      var allItemsLength = jChildContainer.find("input[type=checkbox]").length;
      if ((checkedItemsLength == 0) || (checkedItemsLength != allItemsLength))
        jParentCheckbox.prop("checked", false);
      else
        if (checkedItemsLength == allItemsLength) {
          jParentCheckbox.prop("checked", true);
        }
    });

    return global.settings;
  });

  /*
  * Обновить ссылки управляемых папок по идентификаторам.
  * @return {boolean} Успешное/неуспешное завершение вызова метода веб-сервиса.
  */
  global.settings.updateManagedFoldersLinks = WA.TCD(function (managedFoldersIDs, pasteLinks) {
    ShowTopSpinner();
    WA.SRV.call("/FolderList.asmx/UpdateManagedFoldersLinks", {
      ManagedFoldersIDs: managedFoldersIDs,
      PasteLinks: pasteLinks
    }, "", "", true).always(function (result) {
      HideTopSpinner(L('SETTINGS_SAVED'), 2000);
    });
    return global.settings;
  });

  /*
  * Изменить состояния дочерних чекбоксов и обновить настройки управляемых папок
  * @function changeChildControlsCheckedState
  * @param {object} parentControl
  */
  function changeChildControlsCheckedState(jParentControl) {
    var parentControlIsChecked = $(jParentControl).find("input[type=checkbox]").is(":checked");
    var managedFoldersIDs = [];
    jParentControl.parent().find(".single-managed-folder").each(function () {
      var jChildCheckbox = $(this).find("input[type=checkbox]");
      jChildCheckbox.prop("checked", parentControlIsChecked);
      managedFoldersIDs.push($(this).attr("data-control"));
    });
    global.settings.updateManagedFoldersLinks(managedFoldersIDs, parentControlIsChecked);
  }

  /**
   * Отправить логи на сервер.
   *
   * @function uploadLogs
   * @return {Deferred<Object>} Результат выполнения запроса.
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.settings.uploadLogs = function () {
    var d = $.Deferred();
    var toast = new WA.CMP.NTF.Toast();
    WA.agent.checkSessionState(1).done(function (isSessionRegistered) {
      if (isSessionRegistered) {
        WA.agent.uploadLogs().done((response) => {
          toast.showMessage(L('ERROR_REPORT_SUCCESS_MESSAGE'));
          d.resolve(response);
        }).fail((response) => {
          toast.showMessage(L('ERROR_REPORT_FAIL_MESSAGE'));
          d.reject(response);
        });
      } else {
        ShowWarning(L('LAUNCH_AGENT_TO_SEND_ERROR_REPORT'));
      }
    }).fail(() => {
      ShowWarning(L('LAUNCH_AGENT_TO_SEND_ERROR_REPORT'));
    });

    return d.promise();
  };

})(window.Core);
